import __ from "src/utils/Translations";
import { RequesterType } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import {
  AbsenceTypeOperation,
  IRequester,
} from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

const operationMessageMap = {
  "Złożenie wniosku": [
    AbsenceTypeOperation.ABSENCE_REQUEST_CREATED,
    AbsenceTypeOperation.CHILD_ABSENCE_REQUEST_CREATED,
    AbsenceTypeOperation.PARENT_ABSENCE_REQUEST_CREATED,
    AbsenceTypeOperation.SIBLING_ABSENCE_REQUEST_CREATED,
  ],
  System: [
    AbsenceTypeOperation.BALANCE_CREATED,
    AbsenceTypeOperation.BALANCE_EXPIRED,
    AbsenceTypeOperation.BALANCE_CARRYOVER,
    AbsenceTypeOperation.BALANCE_MODIFIED_PATTERN_EXECUTION,
    AbsenceTypeOperation.PARENT_BALANCE_MODIFIED_PATTERN_EXECUTION,
  ],
  "Wycofanie wniosku": [
    AbsenceTypeOperation.ABSENCE_REQUEST_CANCELLED,
    AbsenceTypeOperation.CHILD_ABSENCE_REQUEST_CANCELLED,
    AbsenceTypeOperation.PARENT_ABSENCE_REQUEST_CANCELLED,
    AbsenceTypeOperation.SIBLING_ABSENCE_REQUEST_CANCELLED,
    AbsenceTypeOperation.CHILD_ABSENCE_REQUEST_REJECTED,
    AbsenceTypeOperation.PARENT_ABSENCE_REQUEST_REJECTED,
  ],
  Korekta: [
    AbsenceTypeOperation.PATTERN_ASSIGNMENT_CHANGED,
    AbsenceTypeOperation.PARENT_PATTERN_ASSIGNMENT_CHANGED,
    AbsenceTypeOperation.BALANCE_MODIFIED,
    AbsenceTypeOperation.PARENT_BALANCE_MODIFIED,
    AbsenceTypeOperation.PARENT_AND_OWN_PATTERN_ASSIGNMENT_CHANGED,
    AbsenceTypeOperation.DAILY_WORKING_HOURS_CHANGED,
  ],
  "Edycja wniosku": [
    AbsenceTypeOperation.ABSENCE_REQUEST_EDITED,
    AbsenceTypeOperation.CHILD_ABSENCE_REQUEST_EDITED,
    AbsenceTypeOperation.PARENT_ABSENCE_REQUEST_EDITED,
    AbsenceTypeOperation.SIBLING_ABSENCE_REQUEST_EDITED,
  ],
  "Akceptacja wniosku": [
    AbsenceTypeOperation.ABSENCE_REQUEST_ACCEPTED,
    AbsenceTypeOperation.CHILD_ABSENCE_REQUEST_ACCEPTED,
  ],
  "Odrzucenie wniosku": [
    AbsenceTypeOperation.ABSENCE_REQUEST_REJECTED,
    AbsenceTypeOperation.SIBLING_ABSENCE_REQUEST_REJECTED,
  ],
  "Import wniosku": [AbsenceTypeOperation.ABSENCE_REQUESTS_IMPORTED],
  "Zmiana ograniczenia składania winosku": [
    AbsenceTypeOperation.SUBMIT_LIMITATIONS_CHANGED,
    AbsenceTypeOperation.PARENT_SUBMIT_LIMITATIONS_CHANGED,
  ],
};

// Messages that append requester info when available
const messagesWithRequester = new Set(["Korekta", "Import wniosku"]);

const resolveWithRequester = (
  message: string,
  requester: IRequester
): string => {
  if (
    requester.type === RequesterType.AHR &&
    requester.firstName &&
    requester.lastName
  ) {
    return `${__(message)}: ${requester.firstName} ${requester.lastName}`;
  }
  if (requester.type === RequesterType.OMB) {
    return __(`${message}: Operator MyBenefit`);
  }
  return __(message);
};

/**
 * Translates operation codes from AbsenceType Balance History API to user-friendly messages
 * @param operationCode - The operation code from the API
 * @param requester - Optional requester information
 * @returns User-friendly message in Polish
 */
export default (
  operationCode: string | undefined,
  requester: IRequester
): string => {
  if (!operationCode) return __("Nieznany");

  // eslint-disable-next-line no-restricted-syntax
  for (const [message, codes] of Object.entries(operationMessageMap)) {
    if (codes.includes(operationCode as AbsenceTypeOperation)) {
      if (messagesWithRequester.has(message) && requester) {
        return resolveWithRequester(message, requester);
      }
      return __(message);
    }
  }

  return __("Nieznany");
};
